module.exports = __webpack_public_path__ + "img/Importspark-NoBG.9976916a.9976916a.svg";